'use strict';
var angular = require('angular');
var PageLevelAlertMessagingService = /** @class */ (function () {
    function PageLevelAlertMessagingService() {
        this.isModalOpen = false;
    }
    return PageLevelAlertMessagingService;
}());
export default PageLevelAlertMessagingService;
//# sourceMappingURL=page-level-alert-messaging.service.js.map